(() => {
  class AiCartQuantityInput extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.input = this.querySelector('input[data-cart-quantity]');
      this.decrease = this.querySelector('[data-cart-quantity-action="decrease"]');
      this.increase = this.querySelector('[data-cart-quantity-action="increase"]');
      if (!this.input || !this.decrease || !this.increase) return;
      this.authoredDisabled ||= new Map();
      for (const button of [this.decrease, this.increase]) {
        if (!this.authoredDisabled.has(button)) this.authoredDisabled.set(button, button.disabled || button.getAttribute('aria-disabled') === 'true');
      }
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.input.addEventListener('change', () => this.refresh(), { signal });
      this.input.addEventListener('input', () => this.input.setCustomValidity(''), { signal });
      this.input.addEventListener('blur', () => {
        if (this.input.value === '') {
          this.input.value = this.input.getAttribute('value');
          this.input.setCustomValidity('');
          this.refresh();
        }
      }, { signal });
      this.refresh();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    nextQuantity(direction) {
      const confirmed = Number(this.input.getAttribute('value'));
      const current = this.input.value === '' ? confirmed : Number(this.input.value);
      const step = Number(this.input.step) || 1;
      const minimum = Math.max(1, Number(this.input.dataset.min) || 1);
      if (direction === 'decrease') {
        const next = Math.floor((current - step) / step) * step;
        return next < minimum ? 0 : next;
      }
      return Math.ceil(Math.max(current + step, minimum) / step) * step;
    }

    refresh() {
      if (!this.input || this.closest('ai-cart-items')?.getAttribute('aria-busy') === 'true') return;
      const current = Number(this.input.value || this.input.getAttribute('value'));
      const maximum = this.input.max === '' ? Infinity : Number(this.input.max);
      const disabled = this.input.disabled || this.input.readOnly;
      this.decrease.disabled = disabled || this.authoredDisabled.get(this.decrease) || current <= 0;
      this.increase.disabled = disabled || this.authoredDisabled.get(this.increase) || this.nextQuantity('increase') > maximum;
    }

    onClick(event) {
      const button = event.target.closest('button[data-cart-quantity-action]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      if (button.disabled || button.getAttribute('aria-disabled') === 'true' || this.input.disabled || this.input.readOnly || this.closest('ai-cart-items')?.getAttribute('aria-busy') === 'true') return;
      const next = this.nextQuantity(button.dataset.cartQuantityAction);
      if (String(next) === this.input.value) return;
      this.input.setCustomValidity('');
      this.input.value = String(next);
      this.refresh();
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('ai-cart-quantity-input')) customElements.define('ai-cart-quantity-input', AiCartQuantityInput);
})();
